import { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';

import MobileButtonContainer from './styles';

// TODO Throttle This

interface MobileStickyNavProps {
  children: React.ReactNode;
  btnpos?: string;
}

const MobileStickyNav = ({ children, btnpos }: MobileStickyNavProps) => {
  const [show, setShow] = useState(false);

  const checkScrollPosition = () => {
    setShow(window.scrollY > 350);
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('scroll', checkScrollPosition);
    }
    return () => {
      if (window) {
        window.removeEventListener('scroll', checkScrollPosition);
      }
    };
  }, []);

  return (
    <CSSTransition
      in={show}
      timeout={{
        enter: 300,
        exit: 700,
      }}
      classNames="mobile-quote"
      unmountOnExit
    >
      <MobileButtonContainer btnpos={btnpos}>{children}</MobileButtonContainer>
    </CSSTransition>
  );
};

export default MobileStickyNav;
